/* eslint-disable react-hooks/exhaustive-deps */
import "./home.css";

import React from "react";
import { Button, TextField, CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";

import { PAGE_ROUTES, LOADING_STATE, STORE_FILTERS } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";
import WithDialog from "../general/WithDialog";

const styles = {
  headerButton: {
    padding: "15px 30px",
  },
  featureButton: {
    width: "100%",
    marginTop: 5,
    height: 60,
    textTransform: "none",
    fontSize: "1em",
    lineHeight: "1.2em",
  },
  servicesPricing: {
    width: "100%",
    maxWidth: 250,
    padding: "15px 30px",
    marginTop: 10,
  },
  subButton: {
    padding: "15px 30px",
    maxWidth: 300,
  },
  shopButton: {
    padding: "20px",
    width: "100%",
    height: "100%",
    lineHeight: "1.2em",
  },
  bookInput: {
    marginBottom: 10,
  },
  bookButton: {
    padding: "15px 30px",
    width: "100%",
  },
  ctaButton: {
    padding: "15px 30px",
  },
};

const signupNewsletter = async (email, setSendState) => {
  setSendState(LOADING_STATE.LOADING);
  const response = await fetch("/api/Contact/SignupNewsletter", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(email),
  });
  if (response.ok) {
    setSendState(LOADING_STATE.LOADED);
  }
  else {
    setSendState(LOADING_STATE.ERROR);
  }
};


const Home = () => {

  const [email, setEmail] = React.useState("");
  const [sendState, setSendState] = React.useState(LOADING_STATE.NOT_LOADING);

  let submitLabel = "Sign up";
  if (sendState === LOADING_STATE.LOADING) {
    submitLabel = <CircularProgress size={25} />;
  }
  else if (sendState === LOADING_STATE.LOADED) {
    submitLabel = "Received! Check your inbox";
  }
  else if (sendState === LOADING_STATE.ERROR) {
    submitLabel = "Retry";
  }

  React.useEffect(() => {
    //Start curator widget
    const script = document.createElement("script");
    script.src = "https://cdn.curator.io/published/43631de1-a42b-40f2-b30e-cafb92328f47.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.HOME]}
        path={PAGE_ROUTES.HOME}
      />
      
      {/* ================================== HERO ================================== */}
      <header className={"home-header"}>
        <div className={"standard-width"}>
          <div className={"home-header-content"}>
            <h1>Ash the dietitian</h1>
            <p>Making <i>food</i> and <i>exercise</i> a<br />part of your <i>balanced</i> lifestyle</p>
            <Link to={PAGE_ROUTES.BOOK}>
              <Button
                variant={"contained"}
                color={"primary"}
                style={styles.headerButton}
              >
                Book now
              </Button>
            </Link>
          </div>
        </div>
        <img
          src={"/images/home/landing-bg1.webp"}
          className={"home-header-img"}
          alt={"Ash The Dietitian - Cape Town & Online Dietitian"}
        />
      </header>

      <section
        className={"home-features-section standard-width"}
        id={"services"}
      >
        <h2 className={"section-head"}>Our services</h2>
        <div className={"home-features"}>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-1.webp"}
              alt={"In-house consultations"}
            />
            <Link to={PAGE_ROUTES.BOOK}>
              <Button
                variant={"contained"}
                color={"secondary"}
                style={styles.featureButton}
              >
                In-house consultations
              </Button>
            </Link>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-6.webp"}
              alt={"Online consultations"}
            />
            <Link to={PAGE_ROUTES.BOOK}>
              <Button
                variant={"contained"}
                color={"secondary"}
                style={styles.featureButton}
              >
                Online consultations
              </Button>
            </Link>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-3.webp"}
              alt={"Meal plans"}
            />
            <WithDialog
              component={
                <Button
                  variant={"contained"}
                  color={"secondary"}
                  style={styles.featureButton}
                >
                  Meal plans
                </Button>
              }
            >
              <div className={"services-modal-inner"}>
                <h3>Meal plans</h3>
                <p>Interested in a personalised meal plan?</p>
                <Link to={PAGE_ROUTES.BOOK}>
                  <Button
                    variant={"outlined"}
                    color={"secondary"}
                    fullWidth
                  >
                    Schedule a consultation
                  </Button>
                </Link>
                <p>Or shop our ready-made plans.</p>
                <Link to={{ pathname: PAGE_ROUTES.STORE, state: { filter: STORE_FILTERS.MEAL_PLANS } }}>
                  <Button
                    variant={"outlined"}
                    color={"secondary"}
                    fullWidth
                  >
                    Ready-made meal plans
                  </Button>
                </Link>
              </div>
            </WithDialog>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-4.webp"}
              alt={"Exercise plans"}
            />
            <Link to={{ pathname: PAGE_ROUTES.STORE, state: { filter: STORE_FILTERS.EXERCISE_PLANS } }}>
              <Button
                variant={"contained"}
                color={"secondary"}
                style={styles.featureButton}
              >
                Exercise plans
              </Button>
            </Link>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-5.webp"}
              alt={"Discovery Vitality Assessments"}
            />
            <WithDialog
              component={
                <Button
                  variant={"contained"}
                  color={"secondary"}
                  style={styles.featureButton}
                >
                  Discovery Vitality Assessments
                </Button>
              }
            >
              <div className={"services-modal-inner"}>
                <h3>Discovery Vitality Assessments</h3>
                <ul>
                  <li>
                    This consultation is an assessment session.
                  </li>
                  <li>
                    In this session we can use the 30 minutes to achieve whatever you need to. There is no set out structure for this consult – you get 1000 points for coming to the consult – therefore, we can use the 30 minutes to talk about any nutrition related goal that you are working towards.
                  </li>
                  <li>
                    <b>Time: 30min</b>
                  </li>
                </ul>
                <Link to={PAGE_ROUTES.BOOK}>
                  <Button
                    variant={"outlined"}
                    color={"secondary"}
                    fullWidth
                  >
                    Schedule a consultation
                  </Button>
                </Link>
              </div>
            </WithDialog>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-2.webp"}
              alt={"Body Composition Analysis"}
            />
            <WithDialog
              component={
                <Button
                  variant={"contained"}
                  color={"secondary"}
                  style={styles.featureButton}
                >
                  Body Composition Analysis (InBody270 & InBody770)
                </Button>
              }
            >
              <div className={"services-modal-inner"}>
                <h3>Body Composition Analysis using the InBody270 or InBody770</h3>
                <ul>
                  <li>
                    This consultation is an Inbody assessment session.
                  </li>
                  <li>
                    In this session we do an Inbody assessment using our Inbody 270 machine.
                  </li>
                  <li>
                    We will help you work towards your goals in this session by helping you understand you focus points as well as some basic dietary advice to help you reach any desired goal.
                  </li>
                  <li>
                    <b>Time: 30min</b>
                  </li>
                </ul>
                <Link to={PAGE_ROUTES.BOOK}>
                  <Button
                    variant={"outlined"}
                    color={"secondary"}
                    fullWidth
                  >
                    Schedule a consultation
                  </Button>
                </Link>
              </div>
            </WithDialog>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-7.webp"}
              alt={"Eating guides"}
            />
            <Link to={{ pathname: PAGE_ROUTES.STORE, state: { filter: STORE_FILTERS.HEALTH_GUIDES } }}>
              <Button
                variant={"contained"}
                color={"secondary"}
                style={styles.featureButton}
              >
                Eating guides
              </Button>
            </Link>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-8.webp"}
              alt={"Corporate services"}
            />
            <Link to={PAGE_ROUTES.CORPORATE}>
              <Button
                variant={"contained"}
                color={"secondary"}
                style={styles.featureButton}
              >
                Corporate services
              </Button>
            </Link>
          </div>
        </div>

        <Button
          variant={"contained"}
          color={"primary"}
          style={styles.servicesPricing}
          href={"/images/home/Ash-Dietitian-Packages.pdf"}
          target={"_blank"}
        >
          See our latest pricing
        </Button>
      </section>

      <section className={"home-sub-section"}>
        <div className={"home-sub-content"}>
          <h2 className={"section-head"}>Subscribe for our bi-monthly menu and shopping list</h2>
          <Link to={"/product/bi-monthly-menu-and-shopping-list"}>
            <Button
              variant={"contained"}
              color={"primary"}
              style={styles.subButton}
            >
              Subscribe now
            </Button>
          </Link>
        </div>
        <img
          className={"home-sub-img"}
          src={"/images/home/sub.webp"}
          alt={"Bi-monthly menu and shopping list subscription"}
        />
      </section>

      <section className={"home-shop-section standard-width"}>
        <h2 className={"section-head"}>Can't see our dietitian for an appointment?</h2>
        <div className={"home-shop-outer"}>
          <img
            className={"home-shop-img"}
            src={"/images/home/plans.webp"}
            alt={"Online meal and exercise plans"}
          />
          <div className={"home-shop-blocks"}>
            <Link
              to={{ pathname: PAGE_ROUTES.STORE, state: { filter: STORE_FILTERS.MEAL_PLANS } }}
              style={{ flex: 1 }}
            >
              <Button
                variant={"contained"}
                color={"primary"}
                style={styles.shopButton}
              >
                Get an online meal plan
              </Button>
            </Link>
            <Link
              to={{ pathname: PAGE_ROUTES.STORE, state: { filter: STORE_FILTERS.EXERCISE_PLANS } }}
              style={{ width: "100%" }}
            >
              <Button
                variant={"contained"}
                color={"primary"}
                style={styles.shopButton}
              >
                Get an online exercise plan
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className={"home-about-section"}>
        <h2 className={"section-head"}>Get to know us</h2>
        <div className={"home-about-inner"}>
          <img
            className={"home-about-img"}
            src={"/images/home/about-1.webp"}
            alt={"Ash The Dietitian - Cape Town Dietitian"}
          />
          <div className={"home-about-content"}>
            <h2>About <u>Ash</u> - Your Cape Town Dietitian</h2>
            <p className={"standard-box"}>
              I studied a B. Dietetics (Hons) at the University of Pretoria
              and graduated in 2018, and also obtained a Higher Certificate in
              Exercise Science through the HFPA
            </p>
            <p className={"standard-box"}>
              I also studied post graduate in Sport Nutrition, PCOS, Skin Health, Plant
              Based Eating and IBS
            </p>
            <p className={"standard-box"}>
              Favourite food – Lemon cheesecake
            </p>
            <p className={"standard-box"}>
              Favourite exercise  – Running and strength training
            </p>
            <p className={"standard-box"}>
              Favourite hobby  – Cooking and recipe development
            </p>
          </div>
        </div>
      </section>

      <section className={"home-maps-section"}>
        <div className={"home-maps-inner"}>
          <h2 className={"section-head"}>Johannesburg</h2>
          <p>
            Inbody Weigh-in Facility, 4 Ashwold Rd, Johannesburg, 2196
          </p>
          <iframe
            src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.0820559714093!2d28.03288441258577!3d-26.161456977007504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e950c63e5fbe02d%3A0x18e484fea4fb3b8f!2s4%20Ashwold%20Rd%2C%20Johannesburg%2C%202196%2C%20South%20Africa!5e0!3m2!1sen!2snl!4v1749021242323!5m2!1sen!2snl"}
            allowFullScreen={true}
            loading={"lazy"}
            referrerPolicy={"no-referrer-when-downgrade"}
            className={"home-map standard-box"}
            title={"Ash The Dietitian Johannesburg Location"}
          />
        </div>
        <div className={"home-maps-inner"}>
          <h2 className={"section-head"}>Cape Town</h2>
          <p>
            V&A Waterfront, Suite 007 (Ground Floor), Granger Bay Court, Granger Road, Cape Town, 8001
          </p>
          <iframe
            src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13245.415829445006!2d18.4238673!3d-33.90628864999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc6750cf9544a5%3A0x1dc3860578bb4780!2sV%26A%20Waterfront!5e0!3m2!1sen!2sza!4v1772104876244!5m2!1sen!2sza"}
            allowFullScreen={true}
            loading={"lazy"}
            referrerPolicy={"no-referrer-when-downgrade"}
            className={"home-map standard-box"}
            title={"Ash The Dietitian Cape Town Location"}
          />
        </div>
      </section>

      <section className={"home-cta-section standard-width"}>
        <img
          className={"home-cta-img standard-box"}
          src={"/images/home/cta.webp"}
          alt={"Book a consultation with Ash The Dietitian"}
        />
        <div className={"home-cta-content"}>
          <h2 className={"section-head"}>Book a consultation</h2>
          <h3>
            Time to focus on <span>you</span>
          </h3>
          <Link to={PAGE_ROUTES.BOOK}>
            <Button
              variant={"contained"}
              color={"primary"}
              style={styles.ctaButton}
              size={"large"}
            >
              Schedule my consultation
            </Button>
          </Link>
        </div>
      </section>

      <section className={"home-book-section standard-width"}>
        <div className={"home-book-outer"}>
          <div className={"home-book-inner"}>
            <div className={"home-book-content"}>
              <h2>Download our free e-book</h2>
              <p>
                Sign up to our newsletter to receive a free copy of our e-book
                "A registered dietitian's top 5 low calorie, high protein recipes".
              </p>
              <TextField
                label={"Email"}
                variant={"outlined"}
                type={"email"}
                style={styles.bookInput}
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                variant={"contained"}
                color={"primary"}
                style={styles.bookButton}
                onClick={() => signupNewsletter(email, setSendState)}
                disabled={(sendState === LOADING_STATE.LOADING) || (sendState === LOADING_STATE.LOADED)}
              >
                {submitLabel}
              </Button>
            </div>
            <img
              className={"home-book-img"}
              src={"/images/home/book.webp"}
              alt={"Top 5 low calorie high protein recipes e-book"}
            />
          </div>
        </div>
      </section>

      <section className={"home-instagram-section"}>
        <h2 className={"section-head"}>Get Social With Us</h2>
        <div id={"curator-feed-ash-layout"}>
          <a
            href={"https://curator.io"}
            target={"_blank"}
            className={"crt-logo crt-tag"}
            rel={"noreferrer"}
          >
            Powered by Curator.io
          </a>
        </div>
      </section>
    </main>
  );
};

export default Home;
